import React, {useEffect, useMemo, useState} from 'react';
import Modal from "../../../components/Modal";
import CandidateProposal from "../../candidate-proposal/CandidateProposal";
import LoadingBanner from "../../../components/LoadingBanner";
import EmptyBanner from "../../../components/EmptyBanner";
import {useIsFetching, useQueryClient} from '@tanstack/react-query';
import useEscapeKey from "../../../hooks/useEscapeKey";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {usePosition} from "../../../providers/ProjectPositionProvider";
import {useProject} from "../../../providers/ClientProjectProvider";
import {clearAllBodyScrollLocks} from "body-scroll-lock";

const ProposalRouteModal = props => {

    const {position} = usePosition();
    const {project} = useProject()
    const location = useLocation();
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const forInvitedTalent = location.pathname.includes("shortlist");
    const queryClient = useQueryClient();
    const [candidate, setCandidate] = useState({});

    const isFetchingCandidate = useIsFetching({ queryKey: ['fetchTalent'] })
    const isFetchingMatches = useIsFetching(['positionMatches']);

    useEffect(() => {
        if(!position && candidate) {
            setTimeout(() => {
                setCandidate({})
            }, 800)
        }
    }, [searchParams.get('tId')]);

    useEffect(() => {
        if(isFetchingMatches) return;

        if (position && parseInt(searchParams.get('tId'))) {

            let options = [];

            try {

                // Find candidate from position matches request
                let queryData = queryClient.getQueriesData({
                    predicate: ({queryKey}) => {
                        let params = queryKey[1] || {};
                        console.log('predicate', params.project_position);

                        return queryKey[0] === 'positionMatches' &&
                            params.project_position === position.id;
                    }
                });
                console.log('positionMatchesProposalRouteCheck', queryData );
                if (queryData.length) {
                    options = TB.flatten(
                        TB.map(queryData, ([queryKey, data]) => data?.users)
                    );
                    options = TB.filter(TB.uniqBy(options, 'id'), user => !!user.id);
                }else {
                    // Find candidate via profile request
                    let candidateProfile = queryClient.getQueryData({
                        predicate: ({queryKey}) => {
                            let params = queryKey[1] || {};
                            return queryKey[0] === 'fetchTalent' &&
                                parseInt(params.profileId) === parseInt(searchParams.get('tId')) &&
                                parseInt(params.position) === position.id;
                        }
                    })
                    console.log('candidateProfileProposalRouteCheck', candidateProfile )
                    if (candidateProfile) {

                        options = [candidateProfile];
                    }
                }
            } catch (e) {
                console.warn(e)
            }
            setCandidate(TB.find(options, ['id', parseInt(searchParams.get('tId'))]))
        }
    }, [searchParams.get('tId'), isFetchingMatches, isFetchingCandidate]);

    const closeProposal = async () => {
        let existingParams =  new URLSearchParams(searchParams);
        existingParams.delete('tId')
        existingParams.delete('tabView')
        await setSearchParams(existingParams, {replace:true});

        await TB.wait(350);
        clearAllBodyScrollLocks()
    }
    const handleEscape = () => {
        if (!!candidate) {
            return closeProposal();
        }
    }

    useEscapeKey(handleEscape)

    const returnRouteParamsString = useMemo(() => {
        if(!searchParams) return '';
        let proposalParams = ['tId', 'tabView'];
        let routeParams = new URLSearchParams()
        searchParams.forEach((value, key) => {
            if(!proposalParams.includes(key)) {
                routeParams.append(key, value);
            }
        })
        return routeParams.toString()
    }, [searchParams.toString()]);

    return (
        <Modal
            key={returnRouteParamsString}
            modalClass="candidate-proposal-modal [&_.modal-container]:p-0"
            defaultScroll={true}
            isVisible={!!position && searchParams.has('tId')}
            allowScrollPagination={false}
            onCloseAction={closeProposal}>

            {candidate?.id ? (
                <CandidateProposal
                    {...props}
                    isDisabled={props.disabled}
                    onClose={closeProposal}
                    position={position}
                    project={project}
                    candidate={candidate}
                    canRequestInterview={false}
                    backBtnTitle={forInvitedTalent ? "Back to candidates" : "Back to talent pool"}
                    onRequest={props.onRequest}
                    key={TB.mapClass(`candidate-${candidate?.id}`, {
                        "-filled": TB.isObject(position?.assigned_candidate),
                        "-assigned": TB.isObject(position?.assigned_candidate) && position?.assigned?.id === candidate?.id,
                    })}
                >

                    {props.children && props.children(candidate)}


                </CandidateProposal>
            ) : (position && (isFetchingMatches || isFetchingCandidate)) ? (
                <div className="proposal-container">
                    <LoadingBanner/>
                </div>
            ) : (
                <EmptyBanner message="candidate not found"/>
            )}

        </Modal>
    );
};

ProposalRouteModal.propTypes = {};

export default ProposalRouteModal;